import RadioCircle from "../../../RadioCircle/RadioCircle";

import classNames from "classnames";
import classes from "./DeliverySlot.module.css";

export default function DeliverySlot(props) {
  const { name, slot, slotText, selectedSlot, onSelect } = props;

  function getSlotDispaly(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("ar", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  let checked = false;
  if (
    selectedSlot &&
    selectedSlot.deliverySlotFrom === slot.from &&
    selectedSlot.deliverySlotTo === slot.to
  ) {
    checked = true;
  }

  return (
    <li
      className={classNames(classes["delivery-slot"], {
        [classes["delivery-slot--checked"]]: checked,
      })}
    >
      <input
        id={`${slot.from}_${slot.to}`}
        className="hidden"
        type="radio"
        name={name}
        value={JSON.stringify(slot)}
        checked={checked}
        onChange={onSelect}
      />
      <label
        className={classes["delivery-slot__label"]}
        htmlFor={`${slot.from}_${slot.to}`}
      >
        <RadioCircle checked={checked} />
        <p className={classes["delivery-slot__label-text"]}>
          {slotText}
          من{" "}
          <span className={classes["delivery-slot__label-slot-text"]}>
            <span className="numeric-content">{getSlotDispaly(slot.from)}</span>{" "}
            - <span className="numeric-content">{getSlotDispaly(slot.to)}</span>
          </span>
        </p>
      </label>
    </li>
  );
}
